import { useContext } from 'react';
import { ConditionalityChartsDataContext } from '../contexts/ConditionalityChartsDataContext';

export const useConditionalityChartsDataContext = () => {
    return useContext(ConditionalityChartsDataContext);
};
